import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, isRef as _isRef, withKeys as _withKeys, createSlots as _createSlots, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5793c864"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white area-subheader" }
const _hoisted_2 = {
  class: "d-flex align-center h-100",
  style: {"padding":"0 50px"}
}
const _hoisted_3 = {
  key: 0,
  class: "ps-2 text-gray-500",
  id: "v-step-welcome"
}
const _hoisted_4 = { class: "text-bold text-gray-900" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "d-flex align-end" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "d-flex gap-1 align-center" }
const _hoisted_9 = { class: "whitespace-nowrap text-gray-500" }
const _hoisted_10 = { id: "v-step-search" }
const _hoisted_11 = { class: "text-sm whitespace-nowrap" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_13 = { class: "d-flex align-center btn-opt" }
const _hoisted_14 = {
  class: "ms-3",
  style: {"width":"120px"}
}
const _hoisted_15 = { class: "text-white my-auto" }
const _hoisted_16 = { class: "text-white my-auto" }
const _hoisted_17 = { class: "text-white text-sm font-500" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_19 = {
  style: {"margin-right":"20px","margin-top":"auto","margin-bottom":"auto"},
  class: "d-flex justify-center",
  id: "v-step-show-hide"
}
const _hoisted_20 = {
  key: 0,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_21 = {
  key: 1,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_22 = { class: "d-flex gap-2" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = {
  key: 1,
  style: {"width":"480px"}
}
const _hoisted_25 = { class: "d-flex align-center justify-end" }
const _hoisted_26 = { class: "mt-2 mx-0 d-flex align-center justify-end" }
const _hoisted_27 = { class: "text-gray-500 text-sm me-4" }
const _hoisted_28 = { class: "text-sm text-gray-950 font-500" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "d-flex align-center" }
const _hoisted_31 = { class: "mt-2 mx-0 d-flex justify-end" }
const _hoisted_32 = {
  key: 0,
  style: {"margin-right":"20px","margin-top":"auto","margin-bottom":"auto"},
  class: "d-flex justify-center",
  id: "v-step-show-hide"
}
const _hoisted_33 = {
  key: 0,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_34 = {
  key: 1,
  class: "text-gray-500 text-sm me-4"
}
const _hoisted_35 = { class: "text-gray-500 text-sm mt-4 me-4" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = { class: "text-white" }
const _hoisted_38 = { style: {"padding":"0.35%"} }

import { MoleculeDataFilter, MoleculeGradesFilter, MoleculeFunctionFilter } from '../molecules'
import { SortIcon, AtomInput, UserSearchIcon, ArrowLeftIcon, AtomButton, GoalFilterIcon, ShowIcon, SlashEyeIcon, ExportIcon } from '../atoms';
import {
	searchBar,
	showInputSearch,
	showBtnMetaAll,
	showFilterByDate,
	showReturn,
	showBradCrumbs,
	bradCrumbs,
	showFilterGrades,
	showColaborators,
	showCadastrarMetas,
	filterRole,
	filterMeta,
	filterNota,
	hasClient,
	hasResale,
	dateMeta,
	iconShowValues,
	exportGoal,
	isTutorial,
	showTutorial,
	isFilterTutorial,
	showModalQuotation
} from '@/store/modules/subBar/index'
import { computed, onMounted, ref, watch } from 'vue';
import { Authentication } from '@/store';

import { format } from 'date-fns';
// import Sidebar from '@/store/modules/sideBar';
// const { showNavigation } = Sidebar();
import { useRoute, useRouter } from 'vue-router';

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
import { selectLocale } from '@/utils/formatDate';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsSubBar',
  setup(__props) {

let locale: string = messages[getLanguage()]['message'];
const location = selectLocale();

const user_name = ref<string>((process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage' ? process.env.VUE_APP_DEFAULT_USER_NAME : Authentication.getters.getUser.value.user?.name ?? ''));

const cookies = document.cookie.split(";");

const route = useRoute();
const router = useRouter();
const menu = ref(false);
const tutorial = ref(false);

const showInformative = ref(true);

const isDashByPerfil = computed(() => {
	return (Authentication.getters.isAdmin.value || Authentication.getters.isMaster.value) && route.name == "Colaboradores" ? true
		: !(Authentication.getters.isAdmin.value || Authentication.getters.isMaster.value) && route.name == 'Dashboard' ? true : false
})

const metaPreview = computed(() => {
	return filterMeta.value?.start_date && filterMeta.value?.end_date ?
		`${toCamelCase(format(new Date(`${filterMeta.value.start_date}T00:00:00`), 'LLLL', { locale: location }))} ${locale['common']['to_date']} ${new Date(`${filterMeta.value.start_date}T00:00:00`).getFullYear()} - ${toCamelCase(format(new Date(`${filterMeta.value.end_date}T00:00:00`), 'LLLL', { locale: location }))} ${locale['common']['to_date']} ${new Date(`${filterMeta.value.end_date}T00:00:00`).getFullYear()}`
		: `${toCamelCase(format(dateMeta.value, 'LLLL', { locale: location }))} ${locale['common']['to_date']} ${dateMeta.value.getFullYear()} `
});

function closeInformative() {
	document.cookie = "informative_readed=true;"
	showInformative.value = false;
}

function goMetas() {
	router.push({
		name: "Metas", query: { especific: 'true' }
	})
}
function toCamelCase(text) {
	// Remover espaços e caracteres especiais
	text = text.replace(/[^a-zA-Z0-9ç]/g, ' ');

	// Dividir as palavras
	const words = text.split(' ');

	// Converter para camelCase
	const camelCaseWords = words.map((word, index) => {
		if (index === 0) {
			// A primeira palavra permanece como está
			return word.toLowerCase();
		} else {
			// Capitalizar a primeira letra das palavras subsequentes
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		}
	});

	// Juntar as palavras para formar o camelCase
	const camelCaseText = camelCaseWords.join('');

	return camelCaseText;
}

function toggleValues() {
	iconShowValues.value = !iconShowValues.value;
}

function handleSearch(event) {
	searchBar.value = event.target.value;
}

function closeMenu() {
	menu.value = false
}

function handleExportGoals() {
	exportGoal.value = !exportGoal.value;
}

watch(
	() => isTutorial.value,
	() => {
		tutorial.value = isTutorial.value;
	}
);

watch(
	() => isFilterTutorial.value,
	() => {
		closeMenu();
	}
);

watch(
	() => showTutorial.value,
	() => {
		const index = cookies.findIndex(e => e.includes("informative_readed"));

		if (index === -1) {
			showInformative.value = !showTutorial.value;
		}
	}
);

onMounted(() => {
	tutorial.value = (Authentication.getters.isMasterOrAdmin.value ? false : isTutorial.value);
	dateMeta.value = new Date();

	const index = cookies.findIndex(e => e.includes("informative_readed"));

	const indexDash = cookies.findIndex(e => e.includes("tutorial_dashboard"));
	const indexMeta = cookies.findIndex(e => e.includes("tutorial_metas"));

	if (indexDash === -1 || indexMeta === -1) {
		showInformative.value = false;
		return;
	}

	if (index !== -1) {
		showInformative.value = false;
		return;
	}
})

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_divider, { class: "" }),
    _createElementVNode("div", _hoisted_2, [
      (isDashByPerfil.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('message.home.greeting')) + ", ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(user_name.value), 1)
          ]))
        : (_unref(showReturn))
          ? (_openBlock(), _createBlock(_unref(AtomButton), {
              key: 1,
              "no-hover": "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              background: "transparent",
              class: "pa-0 mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeftIcon), { class: "mr-12" }),
                (_unref(showBradCrumbs))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(bradCrumbs), (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `${index}-brad`,
                        class: _normalizeClass(`${index === _unref(bradCrumbs).length - 1 ? 'font-600 text-gray-950' : 'text-gray-500 font-500'} text-sm`)
                      }, _toDisplayString(item) + " " + _toDisplayString(index !==
							_unref(bradCrumbs).length - 1 ? '/  ' : ''), 3))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (!_unref(showReturn))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(showBradCrumbs))
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(bradCrumbs), (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `${index}-brad`,
                        class: _normalizeClass(`${index === _unref(bradCrumbs).length - 1 ? 'text-bold' : ''}`)
                      }, _toDisplayString(item) + " " + _toDisplayString(index !==
							_unref(bradCrumbs).length - 1 ? '/  ' : ''), 3))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(showFilterByDate))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('message.goals.filter_goals')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(AtomInput), {
                      modelValue: _unref(searchBar),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchBar) ? (searchBar).value = $event : null)),
                      prependIcon: "",
                      appendIcon: "",
                      noBgPrependIcon: "",
                      noBorderPrependIcon: "",
                      placeholder: _ctx.$t('message.common.goal_name_elipssis'),
                      onKeyup: _withKeys(handleSearch, ["enter"]),
                      width: "314px",
                      classes: "w-100 bg-gray-50"
                    }, _createSlots({
                      prependIcon: _withCtx(() => [
                        _createVNode(_unref(GoalFilterIcon))
                      ]),
                      _: 2
                    }, [
                      (_unref(searchBar))
                        ? {
                            name: "appendIcon",
                            fn: _withCtx(() => [
                              _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (searchBar.value = ''), ["prevent"]))
                              }, "X")
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "placeholder"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_menu, {
                      "close-on-content-click": false,
                      width: "600px"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_unref(AtomButton), _mergeProps({ "no-hover": "" }, props, {
                          background: "white",
                          class: "d-flex align-center gap-1",
                          outlined: ""
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_unref(SortIcon)),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(metaPreview.value), 1),
                            (_unref(filterMeta))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (filterMeta.value = undefined), ["prevent","stop"]))
                                }, "X"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(MoleculeDataFilter), {
                          onHandlePreview: _cache[4] || (_cache[4] = ($event: any) => (dateMeta.value = $event)),
                          onHandleFilter: _cache[5] || (_cache[5] = ($event: any) => (filterMeta.value = $event)),
                          onHandleCancel: _cache[6] || (_cache[6] = ($event: any) => (filterMeta.value = undefined)),
                          "is-goal": true
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(showCadastrarMetas))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_unref(Authentication).getters.isMasterOrAdmin.value)
                          ? (_openBlock(), _createBlock(_unref(AtomButton), {
                              key: 0,
                              background: "white",
                              class: "d-flex align-center my-auto mr-1",
                              style: {"max-height":"50px"},
                              outlined: "",
                              onClick: _withModifiers(handleExportGoals, ["stop"]),
                              "no-hover": ""
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_unref(ExportIcon), { color: "inherit" }),
                                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('message.goals.export')), 1)
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_unref(route).query.especific)
                          ? (_openBlock(), _createBlock(_unref(AtomButton), {
                              key: 1,
                              class: "whitespace-nowrap",
                              background: "primary",
                              style: {"max-height":"50px"},
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'CadastrarMetas' })))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('message.goals.register')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(route).query.especific)
                          ? (_openBlock(), _createBlock(_unref(AtomButton), {
                              key: 2,
                              class: "whitespace-nowrap",
                              background: "primary",
                              style: {"max-height":"50px"},
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({ name: 'CadastrarMetas', query: { especific: 'true' } })))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.goals.register')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(showBtnMetaAll))
            ? (_openBlock(), _createBlock(_unref(AtomButton), { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('message.contributor_summary.all_goals')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_unref(showInputSearch))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_unref(iconShowValues))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('message.common.display')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.home.values')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_21, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('message.common.hide')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.home.values')), 1)
                    ])),
                (_unref(iconShowValues))
                  ? (_openBlock(), _createBlock(_unref(ShowIcon), {
                      key: 2,
                      width: 20,
                      height: 20,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleValues()))
                    }))
                  : (_openBlock(), _createBlock(_unref(SlashEyeIcon), {
                      key: 3,
                      width: 20,
                      height: 20,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleValues()))
                    }))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(AtomInput), {
                  modelValue: _unref(searchBar),
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(searchBar) ? (searchBar).value = $event : null)),
                  prependIcon: "",
                  appendIcon: "",
                  noBgPrependIcon: "",
                  noBorderPrependIcon: "",
                  placeholder: _ctx.$t('message.home.search_for_collaborator'),
                  onKeyup: _withKeys(handleSearch, ["enter"]),
                  width: "314px",
                  classes: "w-100 bg-gray-50",
                  style: _normalizeStyle(_unref(searchBar) === '' ? '' : 'color: #292E36;')
                }, _createSlots({
                  prependIcon: _withCtx(() => [
                    _createVNode(_unref(UserSearchIcon), { empty: _unref(searchBar) }, null, 8, ["empty"])
                  ]),
                  _: 2
                }, [
                  (_unref(searchBar))
                    ? {
                        name: "appendIcon",
                        fn: _withCtx(() => [
                          _createElementVNode("button", {
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (searchBar.value = ''), ["prevent"]))
                          }, "X")
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "placeholder", "style"]),
                _createVNode(_component_v_menu, {
                  "close-on-content-click": false,
                  width: "350px"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_unref(AtomButton), _mergeProps(props, {
                      background: "gray-50",
                      class: "px-10 filter-button",
                      outlined: "",
                      "no-hover": "",
                      style: {"width":"218px"}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_unref(SortIcon)),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('message.common.filters')), 1)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(MoleculeFunctionFilter), {
                      onHandleFilter: _cache[13] || (_cache[13] = ($event: any) => (filterRole.value = $event)),
                      onHandleCancel: _cache[14] || (_cache[14] = ($event: any) => (filterRole.value = $event)),
                      "is-card": true
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(showFilterGrades))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('message.invoices.filter_notes')), 1),
                  _createVNode(_component_v_menu, {
                    modelValue: menu.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((menu).value = $event)),
                    "close-on-content-click": false,
                    width: "450px",
                    height: _unref(hasClient) ? '700px' : '450px'
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_unref(AtomButton), _mergeProps(props, {
                        background: "white",
                        outlined: "",
                        "no-hover": "",
                        style: {"width":"218px"},
                        class: "d-flex align-center gap-2"
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_unref(SortIcon)),
                          _createTextVNode(),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('message.common.filters')), 1),
                          (menu.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (closeMenu()), ["prevent","stop"]))
                              }, "X"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(MoleculeGradesFilter), {
                        onHandleClear: _cache[16] || (_cache[16] = ($event: any) => (filterNota.value = undefined)),
                        onHandleFilter: _cache[17] || (_cache[17] = ($event: any) => ([filterNota.value = $event, closeMenu()])),
                        "has-client": _unref(hasClient),
                        "has-resale": _unref(hasResale)
                      }, null, 8, ["has-client", "has-resale"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "height"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(showColaborators))
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (_unref(Authentication).getters.isMasterOrAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_unref(iconShowValues))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('message.common.display')), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.home.values')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_34, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('message.common.hide')), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.home.values')), 1)
                            ])),
                        (_unref(iconShowValues))
                          ? (_openBlock(), _createBlock(_unref(ShowIcon), {
                              key: 2,
                              width: 20,
                              height: 20,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (toggleValues()))
                            }))
                          : (_openBlock(), _createBlock(_unref(SlashEyeIcon), {
                              key: 3,
                              width: 20,
                              height: 20,
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (toggleValues()))
                            }))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('message.common.filters_text')), 1),
                  _createVNode(_component_v_menu, {
                    "close-on-content-click": false,
                    width: "350px",
                    height: "450px",
                    persistent: tutorial.value,
                    modelValue: menu.value,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((menu).value = $event))
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_unref(AtomButton), _mergeProps(props, {
                        background: "gray-50",
                        outlined: "",
                        "no-hover": "",
                        id: "v-step-filter-button"
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_unref(SortIcon)),
                          _createTextVNode(),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(metaPreview.value), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(MoleculeDataFilter), {
                        onHandlePreview: _cache[21] || (_cache[21] = ($event: any) => (dateMeta.value = $event)),
                        onHandleFilter: _cache[22] || (_cache[22] = ($event: any) => ([filterMeta.value = $event, closeMenu()])),
                        id: "v-step-filter-open",
                        "is-goal-closed": false,
                        "is-roles": false,
                        "is-collaborator": true,
                        onHandleCancel: _cache[23] || (_cache[23] = ($event: any) => (filterMeta.value = undefined))
                      })
                    ]),
                    _: 1
                  }, 8, ["persistent", "modelValue"]),
                  _createVNode(_unref(AtomButton), {
                    background: "primary",
                    class: "ms-4",
                    onClick: goMetas,
                    id: "v-step-goals-button"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('message.contributor_summary.all_goals')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      (showInformative.value && !_unref(showTutorial))
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            closable: "",
            color: "info",
            icon: "$info",
            width: "40%",
            onClick: closeInformative,
            style: {"float":"right"},
            text: _ctx.$t('message.common.information')
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})